import { Modal } from 'antd'
import { FC, useCallback, useRef, useState } from 'react'
import groupImage from '@/assets/secret/group.jpg'

interface FooterEasterEggProps {
  year: number
}

export const FooterHidden: FC<FooterEasterEggProps> = ({ year }) => {
  const [open, setOpen] = useState(false)
  const lastClickRef = useRef<number>(0)
  const clickCountRef = useRef<number>(0)

  const handleClick = useCallback(() => {
    const now = Date.now()
    if (now - lastClickRef.current < 500) {
      clickCountRef.current += 1
    } else {
      clickCountRef.current = 1
    }

    if (clickCountRef.current === 3) {
      setOpen(true)
      clickCountRef.current = 0
    }

    lastClickRef.current = now
  }, [])
  const handleClose = useCallback(() => setOpen(false), [])

  return (
    <>
      <span onClick={handleClick} style={{ cursor: 'default' }} data-testid="mint-footer">
        MINT © {year}
      </span>
      <Modal
        open={open}
        onCancel={handleClose}
        footer={null}
        width={800}
        centered
        destroyOnHidden
        data-testid="mint-easter-egg-modal"
        title={null}
      >
        <img
          src={groupImage}
          alt="MINT team"
          style={{ width: '100%', height: 'auto', display: 'block', marginBottom: 16 }}
        />
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          {open && (
            <iframe
              title="mint-easter-egg-video"
              src="https://www.youtube.com/embed/ZHwVBirqD2s"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </Modal>
    </>
  )
}
